<template>
    <v-row justify="center">
      <v-dialog
        v-model="dialogCerrarSesion"
        persistent
        max-width="500"
        
      >
        <!-- <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="primary"
            dark
            v-bind="attrs"
            v-on="on"
          >
            Open Dialog
          </v-btn>
        </template> -->
        <v-card>
          <v-card-title class="text-h5">
            Desea realmente cerrar la sesión?
          </v-card-title>
          <v-card-text class="mt-10">

              

          </v-card-text> 

        


          <v-card-actions>
            <v-spacer></v-spacer>
            
            
            <v-btn class="mr-2"  outlined color="red darken-1"  text  @click="dialogCerrarSesion=false">
                 <v-icon>
         mdi-cancel
        </v-icon> 
                Cancelar
              </v-btn>
  
              <v-btn class="mr-2" outlined color="blue darken-4" 
              text @click="log();"
             
              >
              <v-icon>
         mdi-check-bold
        </v-icon> 
                Confirmar
              </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </template>


<script>



import router from "@/router/index";


import loginService from "@/services/loginService.js";



  import { 
   
  } from 'vuex'
  export default {
    name:'CerrarSesion',
   data() {
      return {
        dialogCerrarSesion:false,
      
      }
    },
    components:{

     

    },
    computed: {

    },
    methods: {

    openDialog() {
      this.dialogCerrarSesion = true;
    },
    log() {

        loginService.logout().then(res=>{
       
            localStorage.removeItem('token');

            localStorage.removeItem('identificador');
              
        console.log("Token eliminado");

        this.$store.commit('vaciarCarrito');
        this.$store.commit('setLogueado', false);

        alert("Cierre de sesion exitoso");

        this.dialogCerrarSesion=false;

        router.push("/");
        }).catch(e=>{

          console.error(e.response.data.errors);

        })



 
  }

    }
  } 
</script>

